import React, { useRef, useEffect } from 'react';
import { useOutsideClick } from '../../../utils/custom-hooks';

import Icon from '../../ui/icon';

const LinkToValidate = ({
  selectedLinkIndex,
  index,
  newLinkValue,
  setNewLinkValue,
  handleSave,
  handleClickLink,
  link,
  setSelectedLinkIndex,
}) => {
  const inputRef = useRef(null);

  useEffect(() => {
    if (selectedLinkIndex === index) {
      inputRef.current.focus();
      inputRef.current.style.height = `${inputRef.current.scrollHeight}px`;
    }
  }, [selectedLinkIndex]);

  useOutsideClick(
    inputRef,
    () => (selectedLinkIndex === index ? setSelectedLinkIndex(null) : () => {}),
    () => {},
    [selectedLinkIndex],
  );

  return selectedLinkIndex === index ? (
    <div className="link">
      <textarea
        value={newLinkValue}
        onChange={e => setNewLinkValue(e.target.value)}
        ref={inputRef}
      />
      <div className="buttons">
        <button className="save" onClick={handleSave}>
          Save Changes
        </button>
        <button className="cancel" onClick={() => setSelectedLinkIndex(null)}>
          Cancel
        </button>
      </div>
    </div>
  ) : (
    <div className="link">
      <div className="value">
        <a href={link} target="_blank" rel="noopener noreferrer">
          {link}
        </a>
        <div className="pencil" onClick={() => handleClickLink(index, link)}>
          <Icon iconName="pencil" size={12} />
        </div>
      </div>
      <a className="check-link" href={link} target="_blank" rel="noopener noreferrer">
        Check Link
      </a>
    </div>
  );
};

export default LinkToValidate;
